<template>
    <div class="apf">
        <div class="apf-head">
            <span class="ak-label apf-label">Allowed portals</span>
            <div class="apf-modes" role="group" aria-label="Allowed portals">
                <button v-if="allowInherit" type="button" :class="{ on: modelValue.mode === 'inherit' }"
                    @click="setMode('inherit')">Inherit</button>
                <button type="button" :class="{ on: modelValue.mode === 'custom' }" @click="setMode('custom')">Selected</button>
                <button type="button" :class="{ on: modelValue.mode === 'unlimited' }" @click="setMode('unlimited')">All portals</button>
            </div>
        </div>

        <template v-if="modelValue.mode === 'custom'">
            <div v-if="portals.length" class="apf-chips">
                <label v-for="p in portals" :key="p.code" class="apf-chip" :class="{ on: modelValue.value.includes(p.code) }">
                    <input type="checkbox" :checked="modelValue.value.includes(p.code)" @change="toggle(p.code)">
                    {{ p.name || p.code }} <small>{{ p.code }}</small>
                </label>
            </div>
            <div v-else>
                <input type="text" class="ak-input" :value="modelValue.value.join(', ')" placeholder="Portal codes, comma separated"
                    @input="onText">
                <p class="ak-hint">Portal list could not be loaded, enter codes manually.</p>
            </div>
        </template>
        <p v-else-if="modelValue.mode === 'inherit'" class="apf-note">Uses the plan's portals.</p>
        <p v-else class="apf-note">All portals.</p>
    </div>
</template>

<script>
export default {
    name: 'ApiPortalField',
    props: {
        modelValue: { type: Object, required: true },
        portals: { type: Array, default: () => [] },
        allowInherit: { type: Boolean, default: false },
    },
    emits: ['update:modelValue'],
    methods: {
        setMode(mode) {
            this.$emit('update:modelValue', { mode, value: this.modelValue.value });
        },
        toggle(code) {
            const cur = this.modelValue.value;
            const next = cur.includes(code) ? cur.filter(c => c !== code) : [...cur, code];
            this.$emit('update:modelValue', { mode: 'custom', value: next });
        },
        onText(e) {
            const codes = e.target.value.split(',').map(s => s.trim()).filter(Boolean);
            this.$emit('update:modelValue', { mode: 'custom', value: codes });
        },
    },
};
</script>

<style scoped>
.apf { display: flex; flex-direction: column; gap: 0.5rem; }
.apf-head { display: flex; align-items: center; justify-content: space-between; gap: 0.5rem; flex-wrap: wrap; }
.apf-label { margin: 0; }
.apf-modes { display: inline-flex; border: 1px solid #e2e8f0; border-radius: 10px; overflow: hidden; background: #f8fafc; }
.apf-modes button {
    border: none; background: transparent; padding: 0.3rem 0.65rem; font-size: 0.72rem; font-weight: 700;
    color: var(--text-secondary); cursor: pointer; font-family: var(--font-sans);
}
.apf-modes button + button { border-left: 1px solid #e2e8f0; }
.apf-modes button.on { background: #0071C5; color: #fff; }
.apf-note { margin: 0; padding: 0.6rem 0.9rem; border-radius: 10px; background: #f8fafc; color: #64748b; font-size: 0.82rem; font-weight: 600; }
.apf-chips { display: flex; flex-wrap: wrap; gap: 0.4rem; }
.apf-chip {
    display: inline-flex; align-items: center; gap: 6px; padding: 0.35rem 0.7rem; border-radius: 20px;
    border: 1px solid #e2e8f0; background: #f8fafc; font-size: 0.78rem; font-weight: 700; color: var(--text-primary); cursor: pointer;
}
.apf-chip small { color: #94a3b8; font-weight: 600; text-transform: uppercase; }
.apf-chip.on { background: rgba(0, 113, 197, 0.1); border-color: #0071C5; color: #0071C5; }
.apf-chip input { accent-color: #0071C5; }
</style>
